import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

const Truncated = ({ value, maxLength = 30, className = "" }: any) => {
  if (!value) return <span className={className}>-</span>;
  const stringValue = String(value);
  const isTruncated = stringValue.length > maxLength;
  const displayValue = isTruncated ? stringValue.slice(0, maxLength) + "..." : stringValue;

  if (isTruncated) {
    return (
      <Tippy content={stringValue} animation="fade" theme="light">
        <span
          className={`truncate ${className}`}
          style={{
            maxWidth: 190,
            display: "inline-block",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            verticalAlign: "bottom",
          }}
        >
          {displayValue}
        </span>
      </Tippy>
    );
  }
  return (
    <span
      className={`truncate ${className}`}
      style={{
        maxWidth: 200,
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        verticalAlign: "bottom",
      }}
    >
      {displayValue}
    </span>
  );
};

export default Truncated;

export const TruncatedLine = ({ value, maxLength = 30, className = "", lines = 1 }: any) => {
  if (!value) return <span className={className}>-</span>;
  const stringValue = String(value);
  const isTruncated = stringValue.length > maxLength;
  const displayValue = isTruncated ? stringValue.slice(0, maxLength) + "..." : stringValue;

  const truncatedStyle: any = {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: lines, // Use the lines prop to limit the number of lines
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal", // Allow wrapping of text
  };

  if (isTruncated || lines > 1) {
    return (
      <Tippy content={stringValue} animation="fade" theme="light">
        <span className={`text-10 ${className}`} style={{ ...truncatedStyle, maxWidth: 190 }}>
          {displayValue}
        </span>
      </Tippy>
    );
  }

  return (
    <span
      className={`truncate ${className}`}
      style={{
        maxWidth: 200,
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        verticalAlign: "bottom",
      }}
    >
      {displayValue}
    </span>
  );
};
